import styled from 'styled-components';
import TelephoneIconSvg from '../../assets/hotels/amenities/Telephone.svg';

const TelephoneIcon = styled(TelephoneIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default TelephoneIcon;
